var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995361 21.5884C3.25605 27.6812 9.12074 32.0232 16.0002 32.0232C22.8796 32.0232 28.7443 27.6812 31.005 21.5884L16.0002 20.1972L0.995361 21.5884Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.0234375C9.12074 0.0234375 3.25605 4.36544 0.995361 10.4583L16.0002 11.8495L31.005 10.4582C28.7443 4.36544 22.8796 0.0234375 16.0002 0.0234375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.4582C0.352063 12.1915 0 14.0663 0 16.0234C0 17.9805 0.352063 19.8553 0.995188 21.5886H31.0049C31.648 19.8553 32 17.9805 32 16.0234C32 14.0663 31.648 12.1915 31.0048 10.4582H0.995188Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.38bd4f6c.svg";
export { ForwardRef as ReactComponent };